export const CONTACT_FIELDS = [
  { label: 'Contact Name', value: 'contact.name', field_type: ['name'] },
  {
    label: 'Contact Phone',
    value: 'contact.primary_phone',
    field_type: ['phone'],
  },
  {
    label: 'Contact Email',
    value: 'contact.contact_email',
    field_type: ['email'],
  },
  {
    label: 'Contact Address',
    value: 'contact.address',
    field_type: ['address'],
  },
  {
    label: 'Contact Date of birth',
    value: 'contact.contact_dob',
    field_type: ['date'],
  },
  {
    label: 'Contact Comments',
    value: 'contact.contact_comments',
    field_type: ['*'],
  },
];
